<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <!-- <div class="page-name">List Tickets</div> -->
                <div class="page-name">Average TicketBy Time</div>
                <button type="button" class="btn btn-secondary" v-on:click="exportTicket($event)">Export</button>
            </div>

            <div class="admin-page-content">
                <div class="card">
                    <h5 class="card-header ">

                    <div class="">
                        <div class="two-filter">
                            <div class="selectbox1">
                                <v-select v-model="selectedUser" name="user" placeholder="Type name here"
                                          label="name"
                                          :options="userOptions" class="" >
                                </v-select>
                            </div>
                            <div class="selectbox1">
                                <v-select v-model="selectedLocation" name="location" placeholder="Type location here"
                                          label="location_name"
                                          :options="locationOptions" class="" >
                                </v-select>
                            </div>
                        </div>

                        <div class="selectbtn">

                            <button type="button" class="btn btn-warning applybtn" v-on:click="loadTicketAvgTime()">Apply Filter</button>
                            <button type="button" class="btn btn-primary clearbtn" v-on:click="clearFileter()">Clear Filter</button>
                        </div>

                    </div>
                    </h5>
                    <div class="card-body">
                        <vue-good-table
                                :columns="columns"
                                :rows="rows"
                                :line-numbers="true"
                                :searchOptions="{enabled: true,placeholder:'Search by Name'}"
                                :pagination-options="{
                                                enabled: true,
                                                mode: 'pages'
                                              }">
                         </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
    <app-footer></app-footer>
    </div>
</template>

<script>
    import FrontFooter from '@/components/FrontFooter';
    import {HTTP} from '../http-common';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import vSelect from 'vue-select';

    export default {
        name: "AvgTicketTime",
        components: {
            'app-footer':FrontFooter,
            vSelect,
        },
        data() {
            return {
                columns: [
                    {
                        label: 'Number Handled By',
                        field: 'name',
                        filterable: false,
                    },
                    {
                        label: 'Location',
                        field: 'location_name',
                        filterable: false,
                    },
                    {
                        label: 'Numbers Average By Time',
                        field: 'total_time',
                        filterable: false,
                        type:'time',
                    },

                ],
                rows: [],
                selectedUser:'',
                userOptions:[],
                selectedLocation:'',
                locationOptions:[],
                ticketData:{
                    user_id:'',
                    location_id:'',
                },
            }
        },
        mounted:function(){
            let self = this;
            self.loadTicketAvgTime();
            self.loadUser();
            self.loadLocations();
        },
        watch: {
            selectedUser: function (user) {
                let self = this;

                if (self.selectedUser == null) {
                    self.ticketData.user_id = "";
                } else {
                    self.ticketData.user_id = self.selectedUser.id;
                }
            },
            selectedLocation: function (lcoation) {
                let self = this;

                if (self.selectedLocation == null) {
                    self.ticketData.location_id= "";
                } else {
                    self.ticketData.location_id= self.selectedLocation.location_id;
                }
            },
        },
        methods: {
            clearFileter(){
                let self = this;
                self.selectedUser = '',
                self.selectedLocation = '',
                self.ticketData.user_id='';
                self.ticketData.location_id='';
                self.loadTicketAvgTime();
            },
            loadLocations()
            {
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                HTTP.get('locations_new', config)
                    .then(function (response) {
                        // console.log(response);
                        if (response.data.code == '200') {
                            self.locationOptions= response.data.content.row;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            loadUser(){
                let self = this;

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                HTTP.get('getusers', config)
                    .then(function (response) {
                        // console.log(response);
                        if (response.data.code == '200') {
                            self.userOptions= response.data.content;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },

            loadTicketAvgTime() {
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                let ticketData = self.ticketData;
                HTTP.post('avgticket/bytime', ticketData, config)
                    .then(function (response) {
                        // console.log(response);
                        if (response.data.code == '200') {
                            self.rows = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            exportTicket : function (e) {
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                let ticketData = self.ticketData;
                HTTP.post('avgtickettime/export',ticketData,config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            location.href = response.data.content.web;
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/AvgTicketTime.vue